import { render, staticRenderFns } from "./ElTablePaginated.vue?vue&type=template&id=9b98ab84&scoped=true&"
import script from "./ElTablePaginated.vue?vue&type=script&lang=ts&"
export * from "./ElTablePaginated.vue?vue&type=script&lang=ts&"
import style0 from "./ElTablePaginated.vue?vue&type=style&index=0&id=9b98ab84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b98ab84",
  null
  
)

export default component.exports